
/* eslint-disable */

interface Citation {
  title: string;
  text: string;
  url: string;
  source?: string;
  thumbnail?: string;
  metadata?: Record<string, unknown>;
}

/**
 * Function to navigate to a document with a highlight.
 * @param {Citation} citation - The URL of the document.
 */
const navigateToDocumentWithHighlight = (citation: Citation, extension: string, useInline: boolean) => {
  const { completeUrl } = citationToHighlightUrl(citation, extension, useInline)
  window.open(completeUrl);
}

const citationToHighlightUrl = (citation: Citation, extension: string, useInline: boolean = true) => {
  let rendererEndpoint = process.env.REACT_APP_RENDERER_ENDPOINT
  if (extension) {
    rendererEndpoint = process.env.PLASMO_PUBLIC_RENDERER_ENDPOINT
  }

  const { url, text } = citation;
  if (text && useInline) {
    const encodedText = encodeURIComponent(text);
    return {
      url: url,
      highlightEncoded: encodedText,
      completeUrl: `${rendererEndpoint}/?url=${url}&highlight=${encodedText}`
    }
  }
  else {
    return {
      url: url,
      completeUrl: url
    }
  }
}

export { navigateToDocumentWithHighlight, citationToHighlightUrl }

